import type { Prototype } from "../prototype-types";

export const ireneLimbPrototypes: Prototype[] = [
  {
    id: "ads-manager-2",
    name: "[ARCHIVED] Ads Manager 2.0",
    path: "/il/ads-manager-2-archived",
    description:
      "Interview prototype for the revamped Ads Manager: redesigned Overview, per-month conversion drilldown, and a consolidated Customers tab, wired to real advertiser data.",
    owner: "Irene Limb",
    createdAt: "2026-08-04",
    lastUpdated: "2026-09-16",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/ads-manager-2.png",
    figmaLink:
      "https://www.figma.com/design/PHEir6eZP2VcqEn5OD5kOq/Ads-Manager-2.0",
    creationTool: "cursor",
    project: "Ads Manager 2.0",
  },
  {
    id: "ads-manager-2-listen-labs",
    name: "[ARCHIVED] Ads Manager 2.0 for Listen Labs",
    path: "/il/ads-manager-2-listen-labs",
    description:
      "Unmoderated test copy of Ads Manager 2.0, forked so the study can be changed without touching the interview prototype.",
    owner: "Irene Limb",
    createdAt: "2026-09-02",
    lastUpdated: "2026-09-02",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/ads-manager-2.png",
    figmaLink:
      "https://www.figma.com/design/PHEir6eZP2VcqEn5OD5kOq/Ads-Manager-2.0",
    creationTool: "cursor",
    project: "Ads Manager 2.0",
  },
  {
    id: "ads-manager-2-overview",
    name: "[LATEST] Ads Manager 2.0",
    path: "/il/ads-manager-2-overview",
    description:
      "For review 2 of Ads Manager 2.0. Overview, Customers, and Products tabs, with Brand type High data / Low data / EU. Earlier design arms are archived in the toolbar.",
    owner: "Irene Limb",
    createdAt: "2026-10-07",
    lastUpdated: "2026-10-13",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/ads-manager-2.png",
    figmaLink:
      "https://www.figma.com/design/PHEir6eZP2VcqEn5OD5kOq/Ads-Manager-2.0",
    creationTool: "cursor",
    project: "Ads Manager 2.0",
  },
  {
    id: "advanced-settings-education",
    name: "Advanced settings education",
    path: "/il/advanced-settings-education",
    description:
      "Education prototype walking through the General and Advanced advertising settings pages.",
    owner: "Irene Limb",
    createdAt: "2026-07-20",
    lastUpdated: "2026-07-20",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2c6b9b26644f0d7b6c5fa35fc5a9efa0020fbd9fe56aac0467ca8d4d8a97f776.png",
    figmaLink:
      "https://www.figma.com/design/wbnVFL3QGOgwf6Lq5NxMQD/Retailer-Category-Controls",
    creationTool: "cursor",
    project: "Retailer Category Controls",
  },
  {
    id: "ads-advanced-settings",
    name: "Ads Advanced Settings",
    path: "/il/ads-advanced-settings",
    description:
      "Interview prototype for retailer category targeting and new product boosting in Promoted Listings.",
    owner: "Irene Limb",
    createdAt: "2026-07-13",
    lastUpdated: "2026-07-13",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a10af3e1f4ef19977323f8b56e87c6dd66545cea84f26b8ddf93802267d09831.jpeg",
    figmaLink:
      "https://www.figma.com/design/wbnVFL3QGOgwf6Lq5NxMQD/Retailer-Category-Controls",
    creationTool: "cursor",
    project: "Retailer Category Controls",
  },
  {
    id: "ads-social-feed",
    name: "Ads Social Feed",
    path: "/il/ads-social-feed",
    description:
      "Retailer-facing mobile feed surfacing promoted brands or products via a social-style layout. Utilizes videos that brands provide to us.",
    owner: "Irene Limb",
    createdAt: "2026-04-16",
    lastUpdated: "2026-10-12",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/4a2ab17d2069275efab80d695b569a85526df065d6b3c3356455f37161445999.png",
    creationTool: "cursor",
  },
  {
    id: "ads-settings-history",
    name: "Ads Settings History",
    path: "/il/ads-settings-history",
    description:
      "Ads settings history timeline drawer: settings changes by brand users or the system (Promoted Listings).",
    owner: "Irene Limb",
    createdAt: "2026-04-10",
    lastUpdated: "2026-10-12",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/eafb312845ba361f347faf77030aafe9f6c78352b7a0b376e6b0127d63401a5a.png",
    figmaLink:
      "https://www.figma.com/design/Qa0lZYZAErVf5ndXLarbUt/Ads-Settings-History?node-id=12359-72803",
    creationTool: "cursor",
  },
  {
    id: "chart-movement",
    name: "Chart Movement",
    path: "/il/chart-movement",
    description:
      "Demo of how the stacked sales chart in Promoted Listings animates toggling to different months",
    owner: "Irene Limb",
    createdAt: "2026-03-13",
    lastUpdated: "2026-10-12",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/78e31ad77fa3c5c492e44becda9c85e8d740ec6772618538a2c59f454ba1c187.png",
    creationTool: "cursor",
  },
  {
    id: "stepper-responsiveness",
    name: "Stepper Responsiveness",
    path: "/il/stepper-responsiveness",
    description: "Stepper component behavior across breakpoints",
    owner: "Irene Limb",
    createdAt: "2026-03-13",
    lastUpdated: "2026-10-12",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/60176f99bafb7d7458a753bfc5758f5a8ed67ac89569141222f165d11197bd4e.png",
    creationTool: "cursor",
  },
  {
    id: "il-scenario-planning-tool",
    name: "Scenario Planning Tool",
    path: "/il/scenario-planning-tool",
    description:
      "Promoted Listings advertising settings with a live forecast. V1 keeps the monthly forecast beside the budget; V2 uses a Performance forecast card; V3 adds cooking / no-forecast states and spend-vs-capacity guidance.",
    owner: "Irene Limb",
    project: "Promoted Listings",
    createdAt: "2026-10-09",
    lastUpdated: "2026-10-15",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/tm-scenario-planning-tool.png",
    creationTool: "cursor",
  },
];
